import { init, extractCoordinates } from '../google'

const SearchPageGeocoder = {
  mounted() {
    const input = this.el
    const address = input.getAttribute('data-address')
    const lat = document.querySelector(`[data-address="${address}"][data-address-coordinate="lat"]`)
    const lng = document.querySelector(`[data-address="${address}"][data-address-coordinate="lng"]`)
    const city = document.querySelector(`[data-address="${address}"][data-address-field="city"]`) || {}
    const state = document.querySelector(`[data-address="${address}"][data-address-field="state"]`) || {}

    const searchRadius = document.querySelector(`[data-address="${address}"][data-address-coordinate="search_radius"]`)
    const client = input.getAttribute('data-address-mode') === 'client'

    input.addEventListener('input', () => {
      lat.value = ''
      lng.value = ''
      city.value = ''
      state.value = ''
    })

    input.addEventListener('keydown', (event) => {
      if (event.keyCode === 13) {
        event.preventDefault()
        input.dispatchEvent(new Event('change', { bubbles: true }))
      }
    })

    init(input, {}, (result) => {
      const coordinates = extractCoordinates(result)

      lat.value = coordinates.lat;
      lng.value = coordinates.lng;
      city.value = coordinates.city
      state.value = coordinates.state

      // when the user selects a valid location, this pushes an update to live_view if on a live_view page
      if (client === true) {
        input.dispatchEvent(new Event('change', { bubbles: true }))
      } else {
        this.pushEvent('location_update', {
          location: { ...coordinates },
          radius: searchRadius.value,
        })
      }
    })
  },
}

export default SearchPageGeocoder
